// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"728a38c7afaf982c4668","112":"0f78dc7ac0f3b83fb595","113":"aa4956ab64021af37661","160":"053c994a58275199d578"}[chunkId] + ".chunk.js";
};